import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { SpotType } from '@frontend/spot/types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const ID = 'spot-type-select';
export const SpotTypeSelect = (props: Omit<SelectInputV2Props<SpotType>, 'options'>) => {
    return (
        <SelectInputV2<SpotType>
            {...props}
            id={props.id || ID}
            isClearable={props.isClearable ?? true}
            className={props.className}
            options={Object.values(SpotType).map((c) => ({ label: c.replace(/_/g, ' '), value: c }))}
            value={props.value}
            label={props.label || <FormattedMessage
                id='SPOT.TYPE'
                defaultMessage='SPOT type'
                description='Label for spot type select input'
            />}
            required={props.required}
            onSelect={props.onSelect}
        />
    );
};
